import React, { FunctionComponent, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from '@tanstack/react-query';

import { fetchAll, fetchOne } from '../../lib/v31lib';

import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';

import {
  Button as Btn,
  CircularProgress,
  DialogActions,
  Divider,
  Grid,
} from '@mui/material';

import { loginAtom } from '../../lib/auth';

import { AlertCheckInputs } from '../../components/alerts/CheckInputs';
import { AlertSaved } from '../../components/alerts/Saved';
import { AlertSomethingWentWrong } from '../../components/alerts/SomethingWentWrong';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import {
  Page,
  StyledButton,
  StyledIconButton,
  StyledSelect,
  StyledTextField,
  Typography,
} from '../../components/interface';

import {
  Investment,
  InvestmentBreakdown,
  InvestmentManager
} from '../../models';
import { Base } from '../../components/dialogs/Base';

// const { DateTime } = require("luxon");

type Props = {};

export const InvestmentBreakdownDetail: FunctionComponent<Props> = () => {
  const navigate = useNavigate();
  // const theme = useTheme();
  // const { isLoading, isError, data, error } = useQuery({
  //   queryKey: ['login'],
  //   queryFn: async () => {return },
  // });

  const params = useParams();

  const [login, setLogin] = useAtom(loginAtom);
  const [editableObject, setEditableObject] = useState<InvestmentBreakdown|null>({
    rating_data: {
      lines: [
        0.0, 0.0, 0.0, 0.0, 
        0.0, 0.0, 0.0, 0.0, 
        0.0, 0.0, 0.0, 0.0, 
        0.0, 0.0, 0.0, 0.0, 
        0.0, 0.0, 0.0, 0.0, 
        0.0, 0.0, 0.0, 0.0, 
        0.0, 0.0, 0.0, 0.0, 
        0.0, 0.0, 0.0, 0.0
      ]
    }
  });
  const [invId, setInvId] = useState<string | undefined>(params.inv_id);
  const [objectId, setObjectId] = useState<string | undefined>(params.id);

  const [errorSnackOpen, setErrorSnackOpen] = useState<boolean>(false);
  const [serverErrorSnackOpen, setServerErrorSnackOpen] = useState<boolean>(false);
  const [savedOpen, setSavedOpen] = useState<boolean>(false);

  const [compBreakDownPasterOpen, setCompBreakDownPasterOpen] = useState<boolean>(false);
  const [compBreakDownPasterContent, setCompBreakDownPasterContent] = useState<string>('');
  const [sectBreakDownPasterOpen, setSectBreakDownPasterOpen] = useState<boolean>(false);
  const [sectBreakDownPasterContent, setSectBreakDownPasterContent] = useState<string>('');

  const fields = [
    'id', 'created_at', 'updated_at', 'investment_id', 'companies_data', 'rating_data', 'sectors_data'
  ];

  const {
    data: object,
    isLoading: objectLoading,
    isError: objectError,
    isSuccess: objectSuccess,
    refetch: objectRefetch,
  } = useQuery({
    queryKey: ["investment_breakdown", objectId],
    queryFn: () =>
      fetchOne<InvestmentBreakdown>(
        `/nl/v3/objects/fetch_all`,
        {
          object: 'investment_breakdown',
          id: objectId,
          fields: fields
        },
        login
      ),
    // select: (d) => {
    //   return {
    //     ...d,
    //     start_date: DateTime.fromISO(d.start_date).toFormat("dd/LL/y"),
    //     end_date: DateTime.fromISO(d.end_date).toFormat("dd/LL/y"),
    //   };
    // },
    enabled: !!login && parseInt(objectId || '', 10) > 0,
  });

  const {
    data: investments,
    // isLoading: objectsLoading,
    // isError: adviceUploadsError,
    // isSuccess: objectsSuccess,
    // refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["investments"],
    queryFn: () =>
      fetchAll<Investment>(
        `/nl/v3/objects/fetch_all`,
        {
          object: 'investment',
          fields: ['id', 'created_at', 'name', 'latest_breakdown'],
          per_page: 200,
          page: 0,
          order: "name ASC",
          // filter: {
          //   advanced: {
          //     placeholder: 0
          //   }
          // }
        },
        login
      )
  });
  









  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
      keepOpen?: boolean
    }) => {
      return fetchOne<InvestmentBreakdown>(
        `/nl/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setSavedOpen(true);
      if (!variables.keepOpen) navigate("/internal/investments");
      if (!!variables.keepOpen && objectId === 'new') navigate(`/internal/investment_breakdown/${data.id}`);
      if (!!variables.keepOpen && objectId !== 'new') objectRefetch();
    },
  });











  useEffect(() => {
    if (!!object) setEditableObject(object);
  }, [object]);
  useEffect(() => {
    if (!!invId) setEditableObject({
      ...(editableObject || {}),
      investment_id: parseInt(invId, 10)
    });
  }, [invId]);
  useEffect(() => {
    let found:InvestmentBreakdown|undefined = ((investments || []).filter(fff => fff.id?.toString() === editableObject?.investment_id?.toString())[0] || {}).latest_breakdown;
    if (!!found) {
      setEditableObject({
        ...(editableObject || {}),
        companies_data: found.companies_data,
        rating_data: found.rating_data,
        sectors_data: found.sectors_data
      });
    }
  }, [investments, editableObject?.investment_id]);

  return (
    <Page sx={{}} title="Investment Breakdown Detail">
      <Grid container spacing="8">
        <Grid item xs={12}>
          <Typography variant="subtitle1" sx={{
            textDecoration: 'underline'
          }}>Base details</Typography>
        </Grid>
        <Grid item xs={12}>
          <StyledSelect
            label="Investment"
            value={editableObject?.investment_id?.toString() || ''}
            id="investment_id"
            onChange={(v) => {
              setEditableObject({
                ...(editableObject || {
                  name: '',
                  isin: ''
                }),
                investment_id: !!v ? parseInt(v, 10) : undefined
              });
            }}
            list={[
              {id: '', name: "--- ---"},
              ...(investments || []).map(mngr => {
                return {id: mngr.id?.toString() || '', name: mngr.name || ''};
              })
            ]}
          />
        </Grid>



        <Grid item xs={12} sx={{marginTop: 4}}>
          <Typography variant="subtitle1" sx={{
            textDecoration: 'underline',
            display: 'inline'
          }}>Company breakdown</Typography>
          <StyledIconButton onClick={() => {
            setCompBreakDownPasterOpen(true);
          }}>
            <ContentPasteGoIcon color="primary" />
          </StyledIconButton>
        </Grid>
        {(((editableObject || {}).companies_data || {}).lines || []).map((line, i) => <>
          <Grid item xs={1}>

          </Grid>
          <Grid item xs={8}>
            <StyledTextField
              label="Name"
              value={line.name || ''}
              id="line_name"
              onChange={(v) => {
                let newLines:{name: string; percentage: number;}[] = [];
                (((editableObject || {}).companies_data || {}).lines || []).map((ll, ii) => {
                  if (i === ii) {
                    let newLine = {...ll};
                    newLine.name = v;
                    newLines.push(newLine);
                  } else {
                    newLines.push(ll);
                  }
                });

                setEditableObject({
                  ...(editableObject || {}),
                  companies_data: {
                    ...((editableObject || {}).companies_data || {}),
                    lines: newLines
                  }
                });
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={2}>
            <StyledTextField
              label="Pct"
              value={line.percentage?.toString().replace(',', '.').replace(/[^0-9\.]/g, '') || ''}
              id="line_pct"
              onChange={(v) => {
                let newLines:{name: string; percentage: number;}[] = [];
                (((editableObject || {}).companies_data || {}).lines || []).map((ll, ii) => {
                  if (i === ii) {
                    let newLine = {...ll};
                    newLine.percentage = !!v ? parseFloat(v.replace(',', '.').replace(/[^0-9\.]/g, '')) : 0.0;
                    newLines.push(newLine);
                  } else {
                    newLines.push(ll);
                  }
                });

                setEditableObject({
                  ...(editableObject || {}),
                  companies_data: {
                    ...((editableObject || {}).companies_data || {}),
                    lines: newLines
                  }
                });
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={1}>
            <StyledIconButton color="primary" onClick={() => {
              let newLines:{name: string; percentage: number;}[] = [];
              (((editableObject || {}).companies_data || {}).lines || []).map((ll, ii) => {
                if (i === ii) {
                  
                } else {
                  newLines.push(ll);
                }
              });

              setEditableObject({
                ...(editableObject || {}),
                companies_data: {
                  ...((editableObject || {}).companies_data || {}),
                  lines: newLines
                }
              });
            }}>
              <DeleteForeverIcon />
            </StyledIconButton>
          </Grid>
        </>)}
        <Grid item xs={12}>
          <StyledButton
            label="Add line"
            startIcon={<AddCircleIcon />}
            id='add_line'
            onClick={(v) => {
              setEditableObject({
                ...(editableObject || {}),
                companies_data: {
                  ...((editableObject || {}).companies_data || {}),
                  lines: [
                    ...(((editableObject || {}).companies_data || {}).lines || []),
                    {
                      name: '',
                      percentage: 0
                    }
                  ]
                }
              });
            }}
          />
        </Grid>



        <Grid item xs={12} sx={{marginTop: 4}}>
          <Typography variant="subtitle1" sx={{
            textDecoration: 'underline'
          }}>Credit rating breakdown</Typography>
        </Grid>
        {[
          "AAA", '', '', '', 
          "AA+", "AA", "AA−", '',
          "A+", "A", "A−", '',
          "BBB+", "BBB", "BBB−", '',
          "BB+", "BB", "BB−", '',
          "B+", "B", "B−", '',
          "CCC+", "CCC", "CCC−", '',
          "SD/D", '', '', ''
        ].map((name, i) => <>
          {!!name && <>
            <Grid item xs={1}>

            </Grid>
            <Grid item xs={1}>
              <Typography variant="body2" sx={{lineHeight: '50px'}}>{name}</Typography>
            </Grid>
            <Grid item xs={1}>
              <StyledTextField
                label="Pct"
                value={(((editableObject || {}).rating_data || {}).lines || [])[i]?.toString().replace(',', '.').replace(/[^0-9\.]/g, '') || ''}
                id="line_pct"
                onChange={(v) => {
                  let newLines:number[] = [...(((editableObject || {}).rating_data || {}).lines || [])];
                  newLines[i] = !!v ? parseFloat(v.replace(',', '.').replace(/[^0-9\.]/g, '')) : 0.0;

                  setEditableObject({
                    ...(editableObject || {}),
                    rating_data: {
                      ...((editableObject || {}).rating_data || {}),
                      lines: newLines
                    }
                  });
                }}
                fullWidth
              />
            </Grid>
          </>}
          {!name && <Grid item xs={3}></Grid>}
        </>)}



        <Grid item xs={12} sx={{marginTop: 4}}>
          <Typography variant="subtitle1" sx={{
            textDecoration: 'underline',
            display: 'inline'
          }}>Sector breakdown</Typography>
          <StyledIconButton onClick={() => {
            setSectBreakDownPasterOpen(true);
          }}>
            <ContentPasteGoIcon color="primary" />
          </StyledIconButton>
        </Grid>
        {(((editableObject || {}).sectors_data || {}).lines || []).map((line, i) => <>
          <Grid item xs={1}>

          </Grid>
          <Grid item xs={8}>
            <StyledTextField
              label="Name"
              value={line.name || ''}
              id="line_name"
              onChange={(v) => {
                let newLines:{name: string; percentage: number;}[] = [];
                (((editableObject || {}).sectors_data || {}).lines || []).map((ll, ii) => {
                  if (i === ii) {
                    let newLine = {...ll};
                    newLine.name = v;
                    newLines.push(newLine);
                  } else {
                    newLines.push(ll);
                  }
                });

                setEditableObject({
                  ...(editableObject || {}),
                  sectors_data: {
                    ...((editableObject || {}).sectors_data || {}),
                    lines: newLines
                  }
                });
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={2}>
            <StyledTextField
              label="Pct"
              value={line.percentage?.toString().replace(',', '.').replace(/[^0-9\.]/g, '') || ''}
              id="line_pct"
              onChange={(v) => {
                let newLines:{name: string; percentage: number;}[] = [];
                (((editableObject || {}).sectors_data || {}).lines || []).map((ll, ii) => {
                  if (i === ii) {
                    let newLine = {...ll};
                    newLine.percentage = !!v ? parseFloat(v.replace(',', '.').replace(/[^0-9\.]/g, '')) : 0.0;
                    newLines.push(newLine);
                  } else {
                    newLines.push(ll);
                  }
                });

                setEditableObject({
                  ...(editableObject || {}),
                  sectors_data: {
                    ...((editableObject || {}).sectors_data || {}),
                    lines: newLines
                  }
                });
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={1}>
            <StyledIconButton color="primary" onClick={() => {
              let newLines:{name: string; percentage: number;}[] = [];
              (((editableObject || {}).sectors_data || {}).lines || []).map((ll, ii) => {
                if (i === ii) {
                  
                } else {
                  newLines.push(ll);
                }
              });

              setEditableObject({
                ...(editableObject || {}),
                sectors_data: {
                  ...((editableObject || {}).sectors_data || {}),
                  lines: newLines
                }
              });
            }}>
              <DeleteForeverIcon />
            </StyledIconButton>
          </Grid>
        </>)}
        <Grid item xs={12}>
          <StyledButton
            label="Add line"
            startIcon={<AddCircleIcon />}
            id='add_line'
            onClick={(v) => {
              setEditableObject({
                ...(editableObject || {}),
                sectors_data: {
                  ...((editableObject || {}).sectors_data || {}),
                  lines: [
                    ...(((editableObject || {}).sectors_data || {}).lines || []),
                    {
                      name: '',
                      percentage: 0
                    }
                  ]
                }
              });
            }}
          />
        </Grid>


        <Grid item xs={12} sx={{alignContent: 'baseline', textAlign: 'center'}}>
          <Divider sx={{marginTop: 1, marginBottom: 2}} />

          {!!objectLoading && <CircularProgress />}
          {!objectLoading && <StyledButton
            label="Cancel"
            id='cancel'
            // contained
            onClick={(v) => {
              navigate("/internal/investments");
            }}
            sx={{marginLeft: 1}}
          />}
          {!objectLoading && <StyledButton
            label="Save"
            id='save'
            contained
            onClick={(v) => {
              mutationSave.mutate({
                formData: {
                  object: 'investment_breakdown',
                  handler_id: login?.id,
                  id: objectId,
                  fields: fields,
                  ob: {
                    ...editableObject
                  }
                },
                keepOpen: false
              });
            }}
            sx={{marginLeft: 1}}
          />}
        </Grid>
      </Grid>

      {!!serverErrorSnackOpen && <AlertSomethingWentWrong open={serverErrorSnackOpen} setOpen={(b) => {setServerErrorSnackOpen(b);}} />}
      {!!errorSnackOpen && <AlertCheckInputs open={errorSnackOpen} setOpen={(b) => {setErrorSnackOpen(b);}} />}
      {!!savedOpen && <AlertSaved open={savedOpen} setOpen={(b) => {setSavedOpen(b);}} />}

      <Base
        name="companyBreakdownPaster"
        hidden={!compBreakDownPasterOpen}
        maxWidth="xl"
        content={<Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography html>Paste company breakdown from Morningstar here</Typography>
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              label="Content"
              value={compBreakDownPasterContent || ''}
              id="compBreakDownPasterContent"
              onChange={(v) => {
                setCompBreakDownPasterContent(v);
              }}
              fullWidth
              multiline
            />
          </Grid>
          <Grid item xs={12}>
            <StyledButton
              label="Import"
              disabled={!compBreakDownPasterContent}
              id='import'
              onClick={(v) => {
                // console.log(compBreakDownPasterContent.split("\n"));
                // van morningstar wordt elke lijn in 4 gesplit:
                // naam / bullshit met percentage / currency / bullshit dat we negeren

                let total_perc = 0.0;
                let newLines:{name: string; percentage: number;}[] = [];
                let all_lines = compBreakDownPasterContent.split("\n");
                let lines = all_lines.length / 4;
                for (let i = 0; i < lines; i++) {
                  let perc = all_lines[(i * 4) + 1].split("\t")[0].replace(",", ".");
                  total_perc += parseFloat(perc);
                  let newLine = {
                    name: all_lines[i * 4],
                    percentage: parseFloat(perc)
                  };
                  newLines.push(newLine);
                }

                if (total_perc < 100.0) {
                  newLines.push({
                    name: "Other",
                    percentage: (100.0 - total_perc)
                  });
                }

                setEditableObject({
                  ...(editableObject || {}),
                  companies_data: {
                    ...((editableObject || {}).companies_data || {}),
                    lines: newLines
                  }
                });
                setCompBreakDownPasterOpen(false);
                setCompBreakDownPasterContent('');
              }}
            />
          </Grid>
        </Grid>}
        actions={<DialogActions>
          <Btn autoFocus onClick={() => {setCompBreakDownPasterOpen(false);}}>Close</Btn>
        </DialogActions>}
        open={compBreakDownPasterOpen}
        setOpen={setCompBreakDownPasterOpen}
      />

      <Base
        name="csectorBreakdownPaster"
        hidden={!sectBreakDownPasterOpen}
        maxWidth="xl"
        content={<Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography html>Paste sector breakdown (Exposure) from Morningstar here</Typography>
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              label="Content"
              value={sectBreakDownPasterContent || ''}
              id="sectBreakDownPasterContent"
              onChange={(v) => {
                setSectBreakDownPasterContent(v);
              }}
              fullWidth
              multiline
            />
          </Grid>
          <Grid item xs={12}>
            <StyledButton
              label="Import"
              disabled={!sectBreakDownPasterContent}
              id='import'
              onClick={(v) => {
                // console.log(sectBreakDownPasterContent.split("\n"));
                // naam / percent / ignore

                let total_perc = 0.0;
                let newLines:{name: string; percentage: number;}[] = [];
                let all_lines = sectBreakDownPasterContent.split("\n");
                let lines = all_lines.length;
                for (let i = 0; i < lines; i++) {
                  let line = all_lines[i].split("\t");
                  let perc = line[1].replace(",", ".");
                  if (parseFloat(perc) > 0.0) {
                    total_perc += parseFloat(perc);
                    let newLine = {
                      name: line[0].trim(),
                      percentage: parseFloat(perc)
                    };
                    newLines.push(newLine);
                  }
                }

                if (total_perc < 100.0) {
                  newLines.push({
                    name: "Other",
                    percentage: (100.0 - total_perc)
                  });
                }

                setEditableObject({
                  ...(editableObject || {}),
                  sectors_data: {
                    ...((editableObject || {}).sectors_data || {}),
                    lines: newLines
                  }
                });
                setSectBreakDownPasterOpen(false);
                setSectBreakDownPasterContent('');
              }}
            />
          </Grid>
        </Grid>}
        actions={<DialogActions>
          <Btn autoFocus onClick={() => {setSectBreakDownPasterOpen(false);}}>Close</Btn>
        </DialogActions>}
        open={sectBreakDownPasterOpen}
        setOpen={setSectBreakDownPasterOpen}
      />
    </Page>
  );
}
